import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function VisionaryLeader() {
  return <section className="bg-[#f2f2f4] py-24 md:py-32 px-6 border-y border-[#c9a961]/10" data-id="element-337">
      <div className="max-w-7xl mx-auto" data-id="element-338">
        <div className="grid md:grid-cols-12 gap-16 items-center" data-id="element-339">
          {/* Photo Placeholder */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="md:col-span-5 lg:col-span-4" data-id="element-340">
            <div className="aspect-[3/4] bg-[#1d1d1f] relative shadow-2xl overflow-hidden" data-id="element-341">
              <div className="absolute inset-0 border-[1px] border-[#c9a961]/30 m-4 z-10" data-id="element-342" />
              <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-343">
                <div className="w-32 h-32 rounded-full bg-[#c9a961]/10 flex items-center justify-center mb-6 border border-[#c9a961]/30" data-id="element-344">
                  <span className="font-display text-[#c9a961] text-4xl" data-id="element-345">
                    VB
                  </span>
                </div>
                <span className="text-white/80 font-display text-[24px]" data-id="element-346">
                  Mr. Bandi
                </span>
                <span className="text-[#c9a961] text-[12px] uppercase tracking-widest mt-2" data-id="element-347">
                  Managing Director
                </span>
              </div>
            </div>
          </motion.div>

          {/* Content */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="md:col-span-7 lg:col-span-8" data-id="element-348">
            <span className="text-[#c9a961] text-[13px] font-bold tracking-[0.2em] uppercase mb-4 block" data-id="element-349">
              Leadership
            </span>
            <h2 className="font-display text-[40px] md:text-[56px] font-medium text-[#1d1d1f] mb-6 leading-tight" data-id="element-350">
              Our Visionary Leader
            </h2>
            <div className="w-16 h-[1px] bg-[#c9a961] mb-8" data-id="element-351" />
            <h3 className="font-display text-[28px] text-[#1d1d1f] mb-8 italic text-[#c9a961]" data-id="element-352">
              Mr. Vivek Wardhan Bandi
            </h3>

            <div className="space-y-6 text-[#86868b] text-[18px] leading-[1.8] font-light" data-id="element-353">
              <p data-id="element-354">
                A distinguished entrepreneur and industry leader, Mr. Bandi has
                been a proud resident of Bangkok for over 25 years. His journey
                in Thailand began with a three-year professional stint, after
                which he founded J Square Filming Thailand, a premier film
                production house that has successfully completed more than 500
                projects including television commercials, films, documentaries,
                game shows, and music videos for both Indian and international
                markets.
              </p>
              <p data-id="element-355">
                Beyond his achievements in film production, Mr. Bandi has made
                significant contributions to Thailand's culinary landscape as
                the founder and CEO of several renowned restaurant brands. His
                portfolio includes Indian Express, India Greens, Royal Bengal
                Tigers, Malgudi, Cholas, Salaam Namaste, Diffuse, Saffron,
                Malgudi Floating Restaurant, Malgudi Indra Market, Chennai
                Express, Iris, Malgudi Palladium, and Haldi. These
                establishments collectively employ over 500 people in Thailand
                and serve more than 3,000 customers daily.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}